import mod from "-!../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./globalcontact.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./globalcontact.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/vue/globalcontact.vue?vue&type=script&lang=js
// module id = 12
// module chunks = 0